export const getInitialState = () => ({
    isLoading: false,
});

export const JewelryInquiryReducer = (state = getInitialState(), action) => {
    const {
        type,
        data,
    } = action;

    switch (type) {
        case 'UPDATE_JEWELRY_INQUIRY':
            return { ...state, ...data };

        default:
            return state;
    }
};

export default JewelryInquiryReducer;
